(function () {
  if (window.__nestFreeComfortBundleLreRowSync20260703) return;
  window.__nestFreeComfortBundleLreRowSync20260703 = true;

  var targetHandles = [
    'sparrow-signature-hybrid-mattress',
    'owl-natural-latex-hybrid-mattress',
    'starling-signature-contour-grid'
  ];
  var timer = null;
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  var variantSizeById = {
    // Sparrow Signature Hybrid
    '32778464788561': 'Twin',
    '32778464821329': 'Twin',
    '32778464854097': 'Twin',
    '32778464886865': 'Twin XL',
    '32778464919633': 'Twin XL',
    '32778464952401': 'Twin XL',
    '32778465574993': 'Split CK 1-side',
    '32778465607761': 'Split CK 1-side',
    '32778465640529': 'Split CK 1-side',
    '32778464985169': 'Full',
    '32778465017937': 'Full',
    '32778465050705': 'Full',
    '32778464690257': 'Queen',
    '32778464723025': 'Queen',
    '32778464755793': 'Queen',
    '32778465181777': 'King',
    '32778465214545': 'King',
    '32778465247313': 'King',
    '32778465083473': 'King',
    '32778465116241': 'King',
    '32778465149009': 'King',
    '32778465476689': 'Cal King',
    '32778465509457': 'Cal King',
    '32778465542225': 'Cal King',
    '32778465378385': 'Cal King',
    '32778465411153': 'Cal King',
    '32778465443921': 'Cal King',

    // Owl Natural Latex Hybrid
    '32778468556881': 'Twin',
    '32778468589649': 'Twin',
    '32778468622417': 'Twin',
    '32778468655185': 'Twin XL',
    '32778468687953': 'Twin XL',
    '32778468720721': 'Twin XL',
    '32778469343313': 'Split CK 1-side',
    '32778469376081': 'Split CK 1-side',
    '32778469408849': 'Split CK 1-side',
    '32778468753489': 'Full',
    '32778468786257': 'Full',
    '32778468819025': 'Full',
    '32778468458577': 'Queen',
    '32778468491345': 'Queen',
    '32778468524113': 'Queen',
    '32778468950097': 'King',
    '32778468982865': 'King',
    '32778469015633': 'King',
    '32778468851793': 'King',
    '32778468884561': 'King',
    '32778468917329': 'King',
    '32778469245009': 'Cal King',
    '32778469277777': 'Cal King',
    '32778469310545': 'Cal King',
    '32778469146705': 'Cal King',
    '32778469179473': 'Cal King',
    '32778469212241': 'Cal King',

    // Starling Signature Contour
    '40440621989969': 'Twin',
    '40440622088273': 'Twin XL',
    '40440622186577': 'Split CK 1-side',
    '40440622284881': 'Full',
    '40440622415953': 'Queen',
    '40440622514257': 'King',
    '40440622710865': 'Cal King'
  };

  function handle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function isTargetProduct() {
    return targetHandles.indexOf(handle()) !== -1;
  }

  function isMobile() {
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 749;
  }

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/california/ig, 'cal')
      .trim()
      .toLowerCase();
  }

  function installStrongHideStyles() {
    if (document.getElementById('nest-lre-row-sync-strong-hide')) return;
    var style = document.createElement('style');
    style.id = 'nest-lre-row-sync-strong-hide';
    style.textContent = '@media screen and (max-width: 749px) {' +
      '.product-template__container .comfort-bundle-lre[data-nest-lre-hidden="true"] {' +
        'display: none !important; visibility: hidden !important; opacity: 0 !important;' +
      '}' +
      '.product-template__container .comfort-bundle-lre[data-nest-lre-active="true"] {' +
        'display: flex !important; visibility: visible !important; opacity: 1 !important;' +
      '}' +
    '}';
    document.head.appendChild(style);
  }

  function sizeSelect() {
    return document.querySelector('.product-template__container #product-detail-size-chooser');
  }

  function optionSizeText(option) {
    if (!option) return '';
    var text = option.text || option.textContent || '';
    var match = String(text).match(/Twin XL|Split CK 1-side|Cal King|Twin|Full|Queen|King/i);
    return match ? match[0] : text;
  }

  function visibleStyledSizeText() {
    var select = sizeSelect();
    var wrapper = select && select.closest ? select.closest('.select') : select && select.parentElement;
    var styled = wrapper && wrapper.querySelector ? wrapper.querySelector('.styledSelect') : null;
    var text = styled ? styled.textContent : '';
    var match = String(text).match(/Twin XL|Split CK 1-side|Cal King|Twin|Full|Queen|King/i);
    return match ? match[0] : text;
  }

  function selectedVariantId() {
    var selectors = [
      '.product-template__container form[action*="/cart/add"] [name="id"]',
      '.product-template__container [name="id"]',
      'form[action*="/cart/add"] [name="id"]'
    ];
    var fields = [];

    selectors.forEach(function (selector) {
      fields = fields.concat(Array.prototype.slice.call(document.querySelectorAll(selector)));
    });

    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
      var value = String(field.value || '').replace(/\D/g, '');
      if (value && variantSizeById[value]) return value;
    }

    return '';
  }

  function selectedSize() {
    var variantId = selectedVariantId();
    if (variantId && variantSizeById[variantId]) return variantSizeById[variantId];

    var select = sizeSelect();
    if (!select) return '';

    var option = select.options && select.selectedIndex > -1 ? select.options[select.selectedIndex] : null;
    var optionText = optionSizeText(option);

    if (optionText && !/^\d+$/.test(normalize(optionText))) return optionText;
    return visibleStyledSizeText() || optionText || select.value || '';
  }

  function rowSize(row) {
    var size = row.getAttribute('data-size');
    if (size) return size;

    var text = row.textContent || '';
    var match = text.match(/Size:\s*([^$?]+)/i);
    return match ? match[1] : '';
  }

  function matchingRow(rows, size) {
    var normalizedSize = normalize(size);
    var fallback = null;

    for (var i = 0; i < rows.length; i += 1) {
      var rowSizeValue = normalize(rowSize(rows[i]));
      if (!fallback) fallback = rows[i];
      if (rowSizeValue === normalizedSize) return rows[i];
    }

    return fallback;
  }

  function inlineShownRow(rows) {
    for (var i = rows.length - 1; i >= 0; i -= 1) {
      var row = rows[i];
      if (row.style && normalize(row.style.getPropertyValue('display')) === 'flex') return row;
    }
    return null;
  }

  function setClass(row, name, enabled) {
    if (row.classList.contains(name) !== enabled) row.classList.toggle(name, enabled);
  }

  function setAttribute(row, name, value) {
    if (row.getAttribute(name) !== value) row.setAttribute(name, value);
  }

  function removeAttribute(row, name) {
    if (row.hasAttribute(name)) row.removeAttribute(name);
  }

  function setStyle(row, property, value) {
    if (row.style.getPropertyValue(property) === value && row.style.getPropertyPriority(property) === 'important') return;
    row.style.setProperty(property, value, 'important');
  }

  function setVisible(row, visible) {
    setClass(row, 'active', visible);
    setClass(row, 'is-active', visible);
    setAttribute(row, 'aria-hidden', visible ? 'false' : 'true');

    if (visible) {
      removeAttribute(row, 'data-nest-lre-hidden');
      setAttribute(row, 'data-nest-lre-active', 'true');
      setStyle(row, 'display', 'flex');
      setStyle(row, 'visibility', 'visible');
      setStyle(row, 'opacity', '1');
    } else {
      removeAttribute(row, 'data-nest-lre-active');
      setAttribute(row, 'data-nest-lre-hidden', 'true');
      setStyle(row, 'display', 'none');
      setStyle(row, 'visibility', 'hidden');
      setStyle(row, 'opacity', '0');
    }
  }

  function syncBundleRow() {
    if (!isTargetProduct() || !isMobile()) return;
    installStrongHideStyles();

    var rows = Array.prototype.slice.call(document.querySelectorAll('.product-template__container .comfort-bundle-products .comfort-bundle-product.bundle-flex.comfort-bundle-lre'))
      .filter(function (row) {
        return row.hasAttribute('data-size') || /Lifetime Renewal Exchange|Size:/i.test(row.textContent || '');
      });
    if (!rows.length) return;

    var inlineRow = inlineShownRow(rows);
    var selectedRow = inlineRow || matchingRow(rows, selectedSize());

    rows.forEach(function (candidate) {
      setVisible(candidate, candidate === selectedRow);
    });
  }

  function scheduleSync() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      syncBundleRow();
    }, 40);
  }

  function burstSync() {
    [0, 40, 100, 200, 420, 800, 1400].forEach(function (delay) {
      window.setTimeout(syncBundleRow, delay);
    });
  }

  function bind() {
    installStrongHideStyles();
    burstSync();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('#product-detail-size-chooser, [name="id"], select, input')) burstSync();
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('.product-detail-description-right .select, .product-detail-description-right .options li, .product-detail-description-right .styledSelect, .product-form__cart-submit')) {
        burstSync();
      }
    }, true);

    if (window.MutationObserver && document.documentElement) {
      new MutationObserver(scheduleSync).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'selected', 'aria-hidden', 'value']
      });
    }

    if (mobileQuery && mobileQuery.addEventListener) mobileQuery.addEventListener('change', scheduleSync);
  }

  if (!isTargetProduct()) return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();